import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { set as setNotification } from 'store/notification/actions'

// import { update } from 'UserApp/store/user/actions'
import AddressForm from 'UserApp/components/Address/Form'
import { fetchDefault } from 'UserApp/store/address/action'
import { selectAddress } from 'UserApp/store/user/selectors'
import {
  remove,
  create,
  fetchOne,
  update,
} from 'UserApp/store/address/action'
function usersAddress(user) {
  const {
    address,
    address2,
    city,
    state,
    country,
    zip,
    phone,
    shippingAddress = {},
    accessInformation,
  } = user

  return {
    accessInformation,
    address: address || shippingAddress.address,
    address2: address2 || shippingAddress.address2,
    city: city || shippingAddress.city,
    state: state || shippingAddress.state,
    country: country || shippingAddress.country || 'US',
    zip: zip || shippingAddress.zip,
    phone,
  }
}
class AddressFormContainer extends React.PureComponent {
  static propTypes = {
    user: PropTypes.object,
    update: PropTypes.func,
    setNotification: PropTypes.func,
    onClose: PropTypes.func,
  }

  state = { error: '', isProcessing: false }

  handleSubmit = async (data) => {
    const { update, onClose, setNotification, create } = this.props

    this.setState({
      isProcessing: true,
      error: '',
    })

    try {
      console.log(`data ::`,data);
      if(data.id){
        await update(data.id, data)
      } else {
        await create(data)
      }
      
      setNotification(`Address saved`)
      onClose()
    } catch (error) {
      this.setState({
        error,
        isProcessing: false,
      })
    }
  }
  async componentDidMount() {
    await this.props.fetchDefault()
  }

  generateProps = () => {
    return {
      ...this.props,
      ...this.state,
      onSubmit: this.handleSubmit,
    }
  }

  render() {
    const props = this.generateProps()

    return <AddressForm {...props} />
  }
}

export default connect((state) => ({
    user: state.user,
    address: selectAddress(state),
  }), { update, setNotification, fetchDefault, create },
)(AddressFormContainer)
